<template>
  <div id="app">
    <Header />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  color: #333;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

section {
  padding: 60px 0;
}

h2 {
  font-size: 36px;
  text-align: center;
  margin-bottom: 10px;
  color: #333;
}

h2::after {
  content: '';
  display: block;
  width: 60px;
  height: 3px;
  background: #4CAF50;
  margin: 15px auto;
}

.section-desc {
  text-align: center;
  color: #666;
  margin-bottom: 40px;
}

@media (max-width: 768px) {
  section {
    padding: 40px 0;
  }

  h2 {
    font-size: 28px;
  }
}
</style>
